import Tab from "@mui/material/Tab";
import TabContext from "@mui/lab/TabContext";
import TabList from "@mui/lab/TabList";
import TabPanel from "@mui/lab/TabPanel";
import { useState } from "react";
import { Box, Button } from "@mui/material";
import TeamsConfiguration from "./TeamsConfiguration";
import GoogleMeet from "./googleMeetConfiguration";
import { SettingsInputSvideoSharp } from "@mui/icons-material";

const MeetingConfiguration = () => {
  const [value, setValue] = useState("1");
  const [isValuesChange, setValuesChanged] = useState(false);
  const [isChnageModal, setIsChangeModal] = useState(false);
  const [tempValue, settempValue] = useState(0);
  const handleChange = (event, newValue) => {
    if (isValuesChange) {
      settempValue(newValue);
      setIsChangeModal(true);
    } else {
      setValue(newValue);
    }
  };

  const handleOk = () => {
    setValue(tempValue);
    setIsChangeModal(false);
    setValuesChanged(false);
  };

  return (
    <>
      <div className="row w-100 g-0">
        <div className="col-12">
          <TabContext value={value}>
            <Box sx={{ borderBottom: 1, borderColor: "divider" }}>
              <TabList onChange={handleChange}>
                <Tab
                  sx={{ textTransform: "none" }}
                  label="Google Meet"
                  value="1"
                  className="m1 p0 mr-30"
                />
                <Tab
                  sx={{ textTransform: "none" }}
                  label="Microsoft Teams"
                  value="2"
                  className="p0 mr-30"
                />
              </TabList>
            </Box>
            <TabPanel value="1" className="mt-3 ">
              <GoogleMeet setValuesChanged={setValuesChanged}/>
            </TabPanel>
            <TabPanel value="2" className="mt-3 ">
              <TeamsConfiguration setValuesChanged={setValuesChanged}/>
            </TabPanel>
            {/* <TabPanel value="3" className="mt-2 ">
                            <SSO handleLogout={this.props.handleLogout} />
                        </TabPanel> */}
          </TabContext>
        </div>
        <div
          className={`modal modal-style viewbar-overlay  ${
            isChnageModal ? "show" : ""
          }`}
          id="Additionform"
          tabindex="-1"
          aria-labelledby="exampleModalLabel"
          aria-hidden="true"
          style={{ display: isChnageModal ? "block" : "none" }}
        >
          <div className="modal-dialog modal-dialog-centered">
            <div className="modal-content shadow-lg bg-white rounded">
              <div className="modal-body text-center">
                <span>
                  {"Changes are not saved yet"}
                  <br />
                </span>
                <span>{"are you sure you want to close ?"}</span>
              </div>
              <div className="modal-footer justify-content-center">
                <Button
                  className="btn-no px-4"
                  variant="primary"
                  onClick={() => {
                    setIsChangeModal(false);
                  }}
                >
                  No
                </Button>{" "}
                <Button
                  className="btn-action px-4"
                  variant="primary"
                  onClick={() => {
                    handleOk();
                  }}
                >
                  Yes
                </Button>{" "}
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default MeetingConfiguration;
